import { Reducer } from 'redux';

import { IStatsState, IStatsActionTypes, IStats1, IData1, IStats2, IData2, IStats3, IStats4, 
    IStatsEvolutionPerMonth, IGroupInfos, topTitles } from './Types';

let initialState: IStatsState = {
    statsStep1: [],
    statsStep2: [],
    statsStep3: [],
    statsStep4: [],
    statsStep5: [],
    statsFilters1: null,
    statsFilters2: null,
    statsFilters3: null,
    statsFilters4: null,
    statsFilters5: null,
    totalDurationS: undefined,
    periodTitle: '',
    dataRegime: null,
    dataGroup: null,
    dataPerson: null,
    dataMedia: null,
    dataDay: null,
    regimeName: '',
    groupName: '',
    personName: '',
    mediaName: '',
    isLoading: false,
    isLoadingStats1: false,
    regimeColor: -1,
    groupColor: -1,
    personColor: -1,
    statsEvolutionPerMonth: null,
    statsEvolutionFilters: null,
    dataEvolutionPerMonth: null,
    activeTabNames: []
};

const reducer: Reducer<IStatsState> = (state = initialState, action) => {
    switch (action.type) {
        case IStatsActionTypes.GET_STATS_STEP1: {
            return {
                ...state,
                statsFilters1: action.payload[0],
                periodTitle: action.payload[1],
                isLoadingStats1: true,
                regimeName: '',
                groupName: '',
                mediaName: '',
                dataRegime: null,
                activeTabNames: [topTitles[0]]
            };
        }
        case IStatsActionTypes.GET_STATS_STEP1_SUCCESS: {
            let results = action.payload[0] as IStats1[]
            let total_duration_s = action.payload[1]
            let data:IData1[] =[]
            if (results.length > 0) {
                results.map(x => {
                    data.push({
                        political_regime_name: x.political_regime_name,
                        count_broadcast: x.count_broadcast,
                        duration: x.duration_hms,
                        percent: x.percent,
                        color: x.political_regime_color,
                        political_regime_id: x.political_regime_id
                    })
                    return data
                })
            }
            return {
                ...state,
                statsStep1: action.payload,
                dataRegime: data,
                isLoadingStats1: false,
                totalDurationS: total_duration_s
            };
        }
        case IStatsActionTypes.GET_STATS_STEP2: {
            let tabs:any = []
            for (let i=0; i<2; i++) {
                tabs.push(topTitles[i])
            }
            return {
                ...state,
                statsFilters2: action.payload[0],
                regimeName: action.payload[2],
                regimeColor: action.payload[3],
                isLoading: true,
                activeTabNames: tabs
            };
        }
        case IStatsActionTypes.GET_STATS_STEP2_SUCCESS: {
            let results = action.payload as IStats2[]
            let data:IData2[] =[]
            if (results.length > 0) {
                results.map(x => {
                    data.push({
                        political_group_name: x.political_group_name,
                        count_broadcast: x.count_broadcast,
                        duration: x.duration_hms,
                        percent: x.percent,
                        percents_100: x.percents_100,
                        color: x.political_group_color,
                        political_group_id: x.political_group_id
                    })
                    return data
                })
            }
            return {
                ...state,
                statsStep2: action.payload,
                dataGroup: data,
                isLoading: false
            };
        }
        case IStatsActionTypes.GET_STATS_STEP3: {
            let tabs:any = []
            for (let i=0; i<3; i++) {
                tabs.push(topTitles[i])
            }
            return {
                ...state,
                statsFilters3: action.payload[0],
                groupName: action.payload[1],
                groupColor: action.payload[2],
                isLoading: true,
                activeTabNames: tabs
            };
        }
        case IStatsActionTypes.GET_STATS_STEP3_SUCCESS: {
            let results = action.payload as IStats3[]
            let data:any[] =[]
            if (results.length > 0) {
                results.map(x => {
                    data.push({
                        person_name: x.person_name,
                        count_broadcast: x.count_broadcast,
                        duration: x.duration_s,
                        percent: x.percent,
                        person_id: x.person_id
                    })
                    return data
                })
            }
            return {
                ...state,
                statsStep3: action.payload,
                dataPerson: data,
                isLoading: false
            };
        }
        case IStatsActionTypes.GET_STATS_STEP4: {
            let tabs:any = []
            for (let i=0; i<4; i++) {
                tabs.push(topTitles[i])
            }
            return {
                ...state,
                statsFilters4: action.payload[0],
                personName: action.payload[1],
                personColor: action.payload[2],
                isLoading: true,
                activeTabNames: tabs
            };
        }
        case IStatsActionTypes.GET_STATS_STEP4_SUCCESS: {
            let results = action.payload as IStats4[]
            let data:any[] =[]
            if (results.length > 0) {
                results.map(x => {
                    data.push({
                        media_name: x.media_name,
                        count_broadcast: x.count_broadcast,
                        duration: x.duration_hms,
                        percent: x.percent,
                        media_id: x.media_id
                    })
                    return data
                })
            }
            return {
                ...state,
                statsStep4: action.payload,
                dataMedia: data,
                isLoading: false
            };
        }
        case IStatsActionTypes.GET_STATS_STEP5: {
            let tabs:any = []
            for (let i=0; i<5; i++) {
                tabs.push(topTitles[i])
            }
            return {
                ...state,
                statsFilters5: action.payload[0],
                mediaName: action.payload[1],
                isLoading: true,
                activeTabNames: tabs
            };
        }
        case IStatsActionTypes.GET_STATS_STEP5_SUCCESS: {
            return {
                ...state,
                statsStep5: action.payload,
                dataDay: action.payload,
                isLoading: false
            };
        }
        case IStatsActionTypes.GET_STATS_EVOLUTION_PER_MONTH: {
            return {
                ...state,
                statsEvolutionFilters: action.payload,
                isLoading: true
            };
        }
        case IStatsActionTypes.GET_STATS_EVOLUTION_PER_MONTH_SUCCESS: {
            let results = action.payload as IStatsEvolutionPerMonth
            let data:any[] = []
            
            if (Object.keys(results).length > 0) {
                Object.keys(results).map((key:string, index:number) => {
                    let serie = {...results[key]}
                    let dataSerie = {...serie.datas}
                    let dataX:any = {...dataSerie}
                    dataX["month"] = serie.libelle
                    if (dataSerie !== null && dataSerie !== undefined && Object.keys(dataSerie).length > 0) {
                         Object.keys(dataSerie).map((key:string, id:number) => {
                            
                            let dataS:IGroupInfos = dataSerie[key]
                            
                            let libelle = dataS.libelle
                            let percent = 0;
                            if (dataS.percent !== undefined) {
                                percent = dataS.percent.indexOf('%') < 0 ? 0 : parseFloat(dataS.percent.replace('%', ''))
                            }
                            dataX[libelle] = percent
                            return dataX
                        })
                    }
                    data.push(dataX)
                    return data
                })
            }
            return {
                ...state,
                statsEvolutionPerMonth: action.payload,
                dataEvolutionPerMonth: data,
                isLoading: false
            };
        }
        case IStatsActionTypes.GET_STATS_EVOLUTION_PER_MONTH_ERROR: {
            return {
                ...state,
                dataGroup: [],
                isLoading: false
            };
        }
        case IStatsActionTypes.RESET_STATISTICS: {
            return {
                ...initialState
            };
        }
        default: {
            return state;
        }
    }
};

export { reducer as StatsReducer };
